import { useEffect } from 'react';

export function Clarity({ projectId }: { projectId: string }) {
  useEffect(() => {
    if (
      !/^[a-z0-9]+$/i.test(projectId) ||
      document.getElementById('clarity-loader')
    )
      return;
    const target = window as typeof window & {
      clarity?: ((...args: unknown[]) => void) & { q?: unknown[][] };
    };
    target.clarity ||= Object.assign(
      (...args: unknown[]) => {
        target.clarity!.q!.push(args);
      },
      { q: [] as unknown[][] }
    );
    // Keep Clarity in its documented cookieless mode. This still provides
    // limited interaction insights without cross-site advertising cookies.
    target.clarity('consentv2', {
      ad_Storage: 'denied',
      analytics_Storage: 'denied',
    });
    const script = document.createElement('script');
    script.id = 'clarity-loader';
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${projectId}`;
    document.head.appendChild(script);
  }, [projectId]);
  return null;
}
